import React from 'react';

global.saReactComponentRegistry = global.saReactComponentRegistry || {};

/**
 * Gets a registered component by its name.
 *
 * @param name
 * @returns {*}
 */
export const getComponent = (name) => {
  const ret = global.saReactComponentRegistry[name];
  if (!ret){
    throw `${name} is not recognized as a valid react component.  Make sure to call registerComponent on it before rendering`;
  }

  return ret;
};

/**
 * Registers a react component to be rendered by a rails helper.
 *
 * Example:
 *
 * class MyComponent extends React.Component {
 *    render() {...}
 * }
 *
 * registerComponent({MyComponent});
 *
 * Note that the above syntax assumes name of variable/class maps directly to the component's name.  You could also do:
 *
 * registerComponent({"FakeNameForComponent": MyComponent);
 *
 * @param map
 */
export const registerComponent = (map) => {
  const name = Object.keys(map)[0];
  const component = map[name];

  global.saReactComponentRegistry = {
    ...global.saReactComponentRegistry,
    [name]: component
  };
};

/**
 * A react higher order component that registers a react component to be rendered by a rails helper.
 * Useful for registering inline while exporting a connected component.
 *
 * Example:
 *
 * class MyComponent extends React.Component {
 *   render() { ... }
 * }
 *
 * export default registeredComponent("MyComponent")(connect(mapStateToProps)(MyComponent));
 *
 * @param name
 * @returns {function(*): *}
 */
export default (name) => (component) => {
  registerComponent({[name]: component});

  return component;
};